/**
 * Sheet molecule - the one bottom sheet.
 *
 * Owns the backdrop (warm bg-overlay token — not black/NN), the always-on
 * drag handle, slide-up entrance, and bottom safe-area padding.
 * Dark-world screens (camera/media viewers) keep their own inline sheets.
 */
import { type ReactNode } from 'react';

export interface SheetProps {
  open: boolean;
  onClose: () => void;
  title?: ReactNode;
  children: ReactNode;
  className?: string;
}

export default function Sheet({ open, onClose, title, children, className = '' }: SheetProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-overlay" onClick={onClose} />
      <div
        className={`relative max-h-[85vh] w-full overflow-y-auto rounded-t-3xl bg-surface pb-safe shadow-xl animate-slide-up ${className}`}
      >
        <div className="mx-auto mt-3 h-1 w-10 rounded-full bg-border" />
        {title && <h2 className="type-heading px-4 pt-3">{title}</h2>}
        {children}
      </div>
    </div>
  );
}
